import {Hide, Icon} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {ReactNode} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface BreadcrumbItemProps extends TestIdProps {
  children: ReactNode;
  isCurrentPage?: boolean;
  isLastChild?: boolean;
}

const breadcrumbItemVariants = cva(
  'inline-flex items-center text-[length:var(--text-size-x-small)] leading-[var(--text-leading-x-small)] font-normal tracking-[0] text-[var(--color-accent)]'
);

const iconWrapperVariants = cva(
  'mx-1 [&>[role=img]]:pointer-events-none [&>[role=img]]:h-3 [&>[role=img]]:w-3 [&>[role=img]]:text-[length:var(--text-size-x-small)] [&>[role=img]]:leading-[var(--text-leading-x-small)] [&>[role=img]]:font-normal [&>[role=img]]:tracking-[0]'
);

export function BreadcrumbItem(props: BreadcrumbItemProps) {
  return (
    <li
      className={cn(breadcrumbItemVariants())}
      data-testid={suffixTestId('breadcrumbItem', props)}
    >
      {props.children}
      <Hide when={props.isLastChild}>
        <div className={cn(iconWrapperVariants())}>
          <Icon value="navigation/arrow_forward_ios" size={3} color="palettes.neutral.40.100" />
        </div>
      </Hide>
    </li>
  );
}
